import { render, staticRenderFns } from "./NeiBuFile4.vue?vue&type=template&id=6c8fd792&scoped=true&"
import script from "./NeiBuFile4.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile4.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile4.vue?vue&type=style&index=0&id=6c8fd792&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8fd792",
  null
  
)

export default component.exports